import React from "react";
import { reactLocalStorage } from "reactjs-localstorage";
import Constants from "../../util/Constants";
import DailySalesReportAPI from "../../api/DailySalesReportAPI";
import ApiUiController from "../../controller/ApiUiController";
import { CSVLink } from "react-csv";
import { Button, Table } from "react-bootstrap";
import { FaFilter } from "react-icons/fa";
import FilterComplexPannel from "../filter/FilterComplexPannel";
import moment from "moment";

class SalesExecutivePerformanceReport2 extends React.Component {
  constructor(props) {
    super(props);

    const model = reactLocalStorage.getObject(Constants.Model);
    this.lead = model.lead;
    this.call = model.call;
    this.siteVisit = model.meeting || {}; 
    this.userOptions = model.user.options || [];
    this.headers = [
      { label: "Sales Executive", key: "salesperson" },
      { label: "Total leads", key: "leads" },
      { label: "Total completed calls", key: "completedCalls" },
      { label: "Site visit schedule", key: "siteVisitsCreated" },
      { label: "Site visit done", key: "siteVisitsCompleted" }
    ];

    const startOfMonth = moment().startOf("month").format("YYYY-MM-DD");
    const endOfMonth = moment().endOf("month").format("YYYY-MM-DD");
    const startOfMonthTime = moment().startOf("month").format("YYYY-MM-DD HH:mm:ss");
    const endOfMonthTime = moment().endOf("month").format("YYYY-MM-DD HH:mm:ss");

    this.state = {
      tableData: [],
      exportData: [],
      inApiCall: false,
      isFilterOpen: false,
      filters: [
        {
          field: "enquiry_date",
          condition: "in",
          value: `${startOfMonth}~${endOfMonth}`,
          model_key: "lead",
        },
        {
          field: "date_time",
          condition: "in",
          value: `${startOfMonthTime}~${endOfMonthTime}`,
          model_key: "call",
        },
        {
          field: "date_time",
          condition: "in",
          value: `${startOfMonthTime}~${endOfMonthTime}`,
          model_key: "meeting", 
        },
      ],
    };
  }

  componentDidMount() {
    this.fetchReport();
  }

  fetchReport = () => {
    this.setState({ inApiCall: true });

    const leadFilters = this.state.filters.filter(f => f.model_key === "lead");
    const callFilters = this.state.filters.filter(f => f.model_key === "call");
    const siteVisitFilters = this.state.filters.filter(f => f.model_key === "meeting");

    const leadBody = {
      filters: leadFilters,
      model: "lead_model",
      x: "responsible_person",
      y: "",
      z: "COUNT(id)",
    };

    const completedCallsBody = {
      filters: [
        ...callFilters,
        { field: "complete", condition: "not-in", value: "", model_key: "call" }
      ],
      model: "call_model",
      x: "responsible_person",
      y: "",
      z: "COUNT(cl.id)",
    };

    const siteVisitCreatedBody = {
      filters: [
        ...siteVisitFilters,
        { field: "complete", condition: "in", value: "", model_key: "meeting" },
      ],
      model: "meeting_model",
      x: "responsible_person",
      y: "",
      z: "COUNT(mt.id)",
    };

    const siteVisitCompletedBody = {
      filters: [
        ...siteVisitFilters,
        { field: "complete", condition: "not-in", value: "", model_key: "meeting" },
      ],
      model: "meeting_model",
      x: "responsible_person",
      y: "",
      z: "COUNT(mt.id)",
    };

    const makeAPICall = body =>
      new Promise((resolve, reject) =>
        DailySalesReportAPI.getFixedReport(body, resolve, reject)
      );

    Promise.all([
      makeAPICall(leadBody),
      makeAPICall(completedCallsBody),
      makeAPICall(siteVisitCreatedBody),
      makeAPICall(siteVisitCompletedBody)
    ])
      .then(
        ([
          leadData,
          completedCallsData,
          siteVisitCreatedData,
          siteVisitCompletedData
        ]) => {
          this.processData(
            leadData,
            completedCallsData,
            siteVisitCreatedData,
            siteVisitCompletedData
          );
        }
      )
      .catch(() => this.setState({ inApiCall: false }));
  };

  extractUserIds = value => {
    if (!value) return [];
    if (typeof value === "string") return value.split("~").filter(Boolean).map(Number);
    if (typeof value === "number") return [value];
    if (Array.isArray(value)) return value.map(Number);
    return [];
  };

  processData = (
    leadData,
    completedCallsData,
    siteVisitCreatedData,
    siteVisitCompletedData
  ) => {
    const userDataMap = {};
    this.userOptions.forEach(u => {
      userDataMap[u.value] = {
        salesperson: u.label,
        leads: 0,
        completedCalls: 0,
        siteVisitsCreated: 0,
        siteVisitsCompleted: 0,
      };
    });

    const aggregateData = (dataArray, key) => {
      dataArray?.forEach(i => {
        const count = parseInt(i.sum) || 0;
        this.extractUserIds(i.responsible_person).forEach(uid => {
          if (userDataMap[uid]) {
            userDataMap[uid][key] += count;
          }
        });
      });
    };

    aggregateData(leadData, "leads");
    aggregateData(completedCallsData, "completedCalls");
    aggregateData(siteVisitCreatedData, "siteVisitsCreated");
    aggregateData(siteVisitCompletedData, "siteVisitsCompleted");

    const tableData = Object.values(userDataMap).map(r => ({ ...r }));
    const totalRow = {
      salesperson: "TOTAL",
      leads: 0,
      completedCalls: 0,
      siteVisitsCreated: 0,
      siteVisitsCompleted: 0,
    };

    tableData.forEach(r => {
      totalRow.leads += r.leads;
      totalRow.completedCalls += r.completedCalls;
      totalRow.siteVisitsCreated += r.siteVisitsCreated;
      totalRow.siteVisitsCompleted += r.siteVisitsCompleted;
    });

    tableData.push(totalRow);

    this.setState({
      tableData,
      exportData: tableData,
      inApiCall: false,
    });
  };

  toggleFilter = () => {
    this.setState({ isFilterOpen: !this.state.isFilterOpen });
  };

  onFilterChange = filters => {
    this.setState({ filters }, this.fetchReport);
  };

  closeFilter = () => this.setState({ isFilterOpen: false });

  render() {
    const { tableData, exportData, isFilterOpen, filters, inApiCall } = this.state;

    return (
      <ApiUiController inApiCall={inApiCall}>
        <div className="container-fluid">
          <div className="row mb-3 align-items-center">
            <div className="col-md-8">
              <h3 className="mb-0">Sales Executive Performance Report 2</h3>
            </div>
            <div className="col-md-4 text-right">
              <CSVLink
                data={exportData}
                headers={this.headers}
                filename="sales_executive_performance_report.csv"
              >
                <Button className="btn-success shadow-sm">Export</Button>
              </CSVLink>

              <Button
                className="btn btn-primary shadow-sm ml-2"
                onClick={this.toggleFilter}
              >
                <FaFilter className="mr-1" /> Filters
                <span className="badge badge-light text-primary ml-2">
                  {filters.length}
                </span>
              </Button>
            </div>
          </div>

          <div className="row">
            <div className={`col-md-${isFilterOpen ? 9 : 12}`}>
              <div className="card shadow-sm border-0">
                <div className="card-body p-0">
                  <Table bordered hover responsive className="text-center mb-0">
                    <thead className="thead-light">
                      <tr>
                        <th className="text-left border-top-0">Sales Executive</th>
                        <th className="border-top-0">Total Leads</th>
                        <th className="border-top-0">Total Completed Calls</th>
                        <th className="border-top-0">Site Visits schedule</th>
                        <th className="border-top-0">Site Visits done</th>
                      </tr>
                    </thead>
                    <tbody>
                      {tableData.map((r, i) => (
                        <tr
                          key={i}
                          style={{
                            fontWeight: r.salesperson === "TOTAL" ? "700" : "400",
                            background: r.salesperson === "TOTAL" ? "#f8f9fa" : "#ffffff",
                          }}
                        >
                          <td className="text-left">{r.salesperson}</td>
                          <td>{r.leads}</td>
                          <td className="text-primary">{r.completedCalls}</td>
                          <td>{r.siteVisitsCreated}</td>
                          <td className="text-success">{r.siteVisitsCompleted}</td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </div>
              </div>
            </div>

            {isFilterOpen && (
              <FilterComplexPannel
                filters={filters}
                modelX={this.lead}
                modelY={this.call}
                modelZ={this.siteVisit}
                onFilterChange={this.onFilterChange}
                isFilterOpen={isFilterOpen}
                closeFilter={this.closeFilter}
              />
            )}
          </div>
        </div>
      </ApiUiController>
    );
  }
}

export default SalesExecutivePerformanceReport2;